import { useFormContext } from 'react-hook-form';
import {
    Autocomplete,
    AutocompleteOption,
} from 'app/agriculture/forms/components/Autocomplete/Autocomplete';
import './EntityParentSelectField.scss';
import classNames from 'classnames';

interface EntityParentSelectFieldProps {
    className?: string;
    label: string;
    fieldName?: string;
    attachOptions: AutocompleteOption[];
}

export function EntityParentSelectField({
    className,
    label,
    fieldName = 'parentId',
    attachOptions,
}: EntityParentSelectFieldProps) {
    const formController = useFormContext();

    return (
        <Autocomplete
            className={classNames(className, 'EntityParentSelectField')}
            fieldName={fieldName}
            options={attachOptions}
            noun={label}
            formController={formController}
        />
    );
}
